import {TransactionSchema} from '~/entities/transactions-history';

function createCurrentDateAwareFormatter() {
    const monthYearFormat = new Intl.DateTimeFormat('en-gb', {month: 'long', year: 'numeric'});
    const onlyMonthFormat = new Intl.DateTimeFormat('en-db', {month: 'long'});
    const currentYear = new Date().getFullYear();
    return {
        format: (date: Date) => {
            if (date.getFullYear() === currentYear) {
                return onlyMonthFormat.format(date);
            } else {
                return monthYearFormat.format(date).replace(' ', ', ');
            }
        },
    };
}

export const groupOrdersFormattedMonth = (orders: TransactionSchema[]) => {
    const monthGroups = new Map<string, TransactionSchema[]>();
    const formatter = createCurrentDateAwareFormatter();

    for (const order of orders) {
        const dateString = formatter.format(new Date(order.created_at));
        const group = monthGroups.get(dateString);
        if (group) {
            group.push(order);
        } else {
            monthGroups.set(dateString, [order]);
        }
    }

    return monthGroups;
};
